import React, { useEffect, useRef, useState } from "react";
import styles from "./styles.m.css";
import { DeepBI } from "../../../integrations";

const GiftBoxWidget = () => {
  const [opened, setOpened] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [visible, setVisible] = useState(true);
  const giftRef = useRef(null);

  // Open gift animation after 3s
  useEffect(() => {
    const timer = setTimeout(() => {
      setOpened(true);
    }, 3000);
    return () => clearTimeout(timer);
  }, []);

  if (!visible) return null;

  return (
    <div>
      {!showPopup && (
        <div className={styles["gift-main-container"]}>
          <div
            className={styles["close-icon"]}
            onClick={e => {
              e.stopPropagation();
              setVisible(false);
              DeepBI.PingIplQuiz("GiftCloseClicked");
            }}
            title="Close"
            role="button"
            tabIndex={0}
          />

          <div
            ref={giftRef}
            className={`${styles["gift-box-container"]} ${opened ? styles["opened"] : ""}`}
            onClick={() => setShowPopup(true)}
            role="button"
            tabIndex={0}
            aria-label="Open gift box promotion"
          >
            <img
              src="https://images.assettype.com/vikatan/2025-06-20/40516uxp/giftbox-new.png"
              alt="Gift Box"
              className={styles["gift-box"]}
            />
          </div>
        </div>
      )}

      {showPopup && (
        <div className={styles["content-section"]}>
          <div className={styles["content-wrapper"]}>
            <img
              src="https://images.assettype.com/vikatan/2025-06-20/40516uxp/giftbox-new.png"
              alt="Vikatan Play Logo"
              className={styles["popup-vikatan-logo"]}
            />
            <h2>1 மாத விகடன் சந்தா இலவசம்!</h2>
            <p>விகடன் App-ஐ இன்ஸ்டால் செய்து, விளம்பரமில்லாமல் பிரீமியம் கட்டுரைகளை அனுபவியுங்கள்!</p>
            <div className={styles["new-user"]}>*For New Registrations only</div>
            <div className={styles["cta-wrap"]}>
              <button
                className={styles["close-btn"]}
                onClick={e => {
                  e.stopPropagation();
                  setShowPopup(false);
                  DeepBI.PingIplQuiz("GiftRegretClicked");
                }}
                type="button"
              >
                {"I'll Regret this"}
              </button>

              <button className={styles["claim-btn"]} type="button">
                <a
                  href="https://onelink.to/hmt6pa"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles.claimBtn}
                >
                  Tap to Claim
                </a>
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default GiftBoxWidget;
